import { jsx as _jsx } from "react/jsx-runtime";
import { MenuSubitem } from "../MenuSubitem";
import { NothingFoundSpan } from "../styles";
import { MENU_CONSTANTS } from "../../../utils/consts";
export var MenuContent = function (_a) {
    var activeSearch = _a.activeSearch, sideBarOpen = _a.sideBarOpen, searchItemsFiltered = _a.searchItemsFiltered, bodyItems = _a.bodyItems, onSearchChange = _a.onSearchChange, renderMenuItem = _a.renderMenuItem;
    if (activeSearch && sideBarOpen) {
        return searchItemsFiltered.length > 0 ? (searchItemsFiltered.map(function (item, index) { return (_jsx(MenuSubitem, { subitem: item, setSearch: onSearchChange }, (item.path || "") + index)); })) : (_jsx(NothingFoundSpan, { style: { textAlign: "center" }, children: MENU_CONSTANTS.SEARCH.NO_RESULTS }));
    }
    return bodyItems.map(renderMenuItem);
};
//# sourceMappingURL=index.js.map